import axios from "axios";

const api = axios.create({
    baseURL: "/api",
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) prom.reject(error);
        else prom.resolve(token);
    });
    failedQueue = [];
};

// 🔵 REQUEST INTERCEPTOR
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// 🔴 RESPONSE INTERCEPTOR (AUTO REFRESH)
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        // only handle 401
        if (error.response?.status !== 401) {
            return Promise.reject(error);
        }

        // avoid infinite loop
        if (originalRequest._retry) {
            return Promise.reject(error);
        }

        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({
                    resolve: (token) => {
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        resolve(api(originalRequest));
                        },
                    reject: (err) => reject(err),
                });
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
            const refresh_token = localStorage.getItem("refresh_token");

            if (!refresh_token) {
                throw new Error("No refresh token");
            }

            const res = await axios.post("/api/auth/refresh", {}, {
                headers: {
                    Authorization: `Bearer ${refresh_token}`,
                },
            });

            const newAccessToken = res.data.access_token;

            localStorage.setItem("access_token", newAccessToken);

            api.defaults.headers.Authorization = `Bearer ${newAccessToken}`;

            processQueue(null, newAccessToken);

            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

            return api(originalRequest);

        } catch (err) {
            processQueue(err, null);

            // 🔥 logout if refresh fails
            localStorage.clear();
            window.location.href = "/login";

            return Promise.reject(err);

        } finally {
            isRefreshing = false;
        }
    });

export default api;